import React, { Component } from 'react';
import CheckDefecto from '../../../../../Common/Components/CheckDefecto';
import OpcionDefecto from '../../../../../Common/Components/OpcionDefecto';
import ExpHelper from '../../../../../Common/Helpers/ExpHelper';

const AltaPosDatadaCabal = ({ data, selectRadio, selectCheckBox, selectCombo }) => {
    const { GET_ALTA_POSDATADA } = data;
    let arrayAux = GET_ALTA_POSDATADA.filter(d => d.Checked);
    let acentoLetraOminuscula = ExpHelper.ConvertirCaracter("o");
    let letraNminuscula = ExpHelper.ConvertirCaracter("n");
    const acentoLetraAminuscula = ExpHelper.ConvertirCaracter("a");

    return (
        <div className="row top-separator-xs">
            <div className="col-xs-12">
                <label className="label-primary">{"Alta Pos Datada"}</label>
                <div className="container-radio radio-margin">

                    <CheckDefecto nombre={"Se" + letraNminuscula + "al de Alta Pos Datada"}
                        referencia={"HabilitarAltaPosDatada"}
                        check={data.HabilitarAltaPosDatada}
                        selectCheckBox={({ target }) => selectCheckBox("HabilitarAltaPosDatada", target.checked)} />

                    <div className="row">

                    {data.HabilitarAltaPosDatada && <div className="col-xs-12 left-separator-xs top-separator-xxs">
                        {GET_ALTA_POSDATADA.map( ( item ) => {
                            const referencia = `GATPDT-${item.Id}`;

                            return (
                                <CheckDefecto
                                    key={item.Id}
                                    nombre={item.Descripcion}
                                    check={item.Checked}
                                    activo={item.Activo}
                                    referencia={referencia}
                                    selectCheckBox={() => {
                                        if ( data.HabilitarAltaPosDatada ) {
                                            selectCheckBox( "GET_ALTA_POSDATADA", item.Id );
                                        }
                                    }}
                                />
                            )
                        } )}
                    </div>}
                    
                    <div className="col-xs-12">
                    {data.HabilitarAltaPosDatada && <OpcionDefecto
                            infoData={arrayAux}
                            referencia={"AltaPosDatadaDefaultId"}
                            valorCombo={data.AltaPosDatadaDefaultId}
                            valorChecked={data.AltaPosDatadaDefaultInterfaz}
                            selecciono={arrayAux.length}
                            selectCombo={(value) => selectCombo("AltaPosDatadaDefaultId", value)}
                            selectCheckBox={(value) => selectCheckBox("AltaPosDatadaDefaultInterfaz", value)}
                        />}

                        {data.ERROR_PRODUCT["seleccionoAltaPosDatada"] == false && arrayAux.length<1 ? <label className="error">{"Debe seleccionar al menos una señal de Alta Pos Datada."}</label> : null}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AltaPosDatadaCabal;